export default angular.module('edge.gateway.policyjob.app', [])
    .value('policyjob.endpointConfig', {
        'vinlookup': 'gatewayvehicleinfo/lookup',
        'availability': 'gatewayavailability'
    })
    .value('policyjob.xCenterRouteConfig', 'pc');